<template>
  <top-navigation></top-navigation>
  <div id="cursor"></div>
  <router-view v-slot="{ Component }">
    <transition name="fadeIn">
      <component :is="Component" />
    </transition>
  </router-view>
  <footer-bottom></footer-bottom>
  <bottom-navigation></bottom-navigation>
</template>
<script>
import TopNavigation from "./components/navigation/TopNavigation.vue";
import BottomNavigation from "./components/navigation/BottomNavigation.vue";
import FooterBottom from "./components/navigation/Footer.vue";
import { onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
export default {
  components: {
    BottomNavigation,
    TopNavigation,
    FooterBottom,
  },
  setup() {
    onMounted(() => {
      const cursor = document.getElementById("cursor");
      document.onmousemove = (e) => {
        cursor.style.left = e.pageX - 10 + "px";
        cursor.style.top = e.pageY - 10 + "px";
      };
    });
    const store = useStore();
    store.dispatch("getProjects");
  },
};
</script>
<style>
html {
  scroll-behavior: smooth;
}
/* width */
::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #765cd1;
}

.container {
  margin: 0 auto;
  max-width: 1280px;
  width: 90% !important;
}
@media only screen and (max-width: 601px) {
  .container {
    width: 96% !important;
  }
}
@media only screen and (min-width: 993px) {
  .container {
    width: 85% !important;
  }
}
@import "https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp";

@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/Raleway-VariableFont_wght.ttf");
}

* {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

.fadeIn-enter-active {
  animation: fadeIn 0.6s ease-out;
}

.fadeIn-leave-active {
  animation: fadeOut 0.2s ease-in delay 0.2s;
}
@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}
body {
  cursor: pointer;
  width: 100%;
  overflow-x: hidden;
}
#cursor {
  width: 20px;
  height: 20px;
  background: rgb(33, 50, 206);
  border-radius: 50%;
  position: absolute;
  transition-duration: 0.5s;
  transition-timing-function: ease-out;
  animation: at-ripple-pink 0.6s linear infinite;
}
@-webkit-keyframes at-ripple-pink {
  0% {
    box-shadow: 0 4px 10px rgba(65, 78, 255, 0.1),
      0 0 0 0 rgba(255, 65, 130, 0.1), 0 0 0 5px rgba(84, 65, 255, 0.1),
      0 0 0 10px rgba(100, 65, 255, 0.1);
  }
  100% {
    box-shadow: 0 4px 10px rgba(68, 65, 255, 0.1),
      0 0 0 5px rgba(78, 65, 255, 0.1), 0 0 0 10px rgba(65, 100, 255, 0.1),
      0 0 0 20px rgba(122, 65, 255, 0);
  }
}
@keyframes at-ripple-pink {
  0% {
    box-shadow: 0 4px 10px rgba(94, 65, 255, 0.1),
      0 0 0 0 rgba(54, 57, 236, 0.1), 0 0 0 5px rgba(65, 109, 255, 0.1),
      0 0 0 10px rgba(65, 94, 255, 0.1);
  }
  100% {
    box-shadow: 0 4px 10px rgba(67, 50, 218, 0.1),
      0 0 0 5px rgba(65, 68, 255, 0.1), 0 0 0 10px rgba(80, 56, 212, 0.1),
      0 0 0 20px rgba(65, 68, 255, 0);
  }
}
@media only screen and (max-width: 600px) {
  #cursor {
    display: none;
  }
  body {
    cursor: none;
  }
}
</style>
